import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetTestingProgramsSuspense } from "api/generated/testing-programs/testing-programs";

export function useTestingProgramsQuery() {
    return useGetTestingProgramsSuspense({
        query: {
            select: (response) => response.data,
            refetchOnMount: true,
            refetchOnWindowFocus: true,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
